function formatRebuyPrice(price) {
  if (typeof price === "string") {
    price = parseFloat(price) * 100;
  } else if (typeof price === "number") {
    price = price; 
  }

  return price;
}

async function getVariantPricing(handle, variantId) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error(`Failed to fetch product data: ${res.status}`);
    const productData = await res.json();

    const matchedVariant = productData.variants.find(v => v.id == variantId);
    if (matchedVariant) {
      return {
        price: matchedVariant.price,
        compareAtPrice: matchedVariant.compare_at_price || null
      };
    }

    console.warn(`Variant ${variantId} not found for product ${handle}`);
    return { price: null, compareAtPrice: null };

  } catch (err) {
    console.error("Error fetching variant pricing via AJAX API:", err);
    return { price: null, compareAtPrice: null };
  }
}

  // --- Helper to get compare_at_price dynamically ---
  const getCompareAtPrice =  (item, props) => {
    if (props["_compare_at_price"] && props["_compare_at_price"] !== "0") {
      return parseFloat(props["_compare_at_price"]);
    }
    if (IS_US && item.product?.selected_variant?.compare_at_price) {
      return formatRebuyPrice(item.product.selected_variant.compare_at_price);
    }
    // if (!IS_US) {
    //   const { compareAtPrice } = await getVariantPricing(item.product.handle, item.product.selected_variant.id);
    //   if (compareAtPrice) return formatRebuyPrice(compareAtPrice);
    // }
    if (item.final_price < item.original_price) {
      return item.original_price;
    }
    return null;
  };


 function rebuyDiscountMessages(item) {
  if (!item || item.product?.tags?.includes("smart-cart-hidden")) return "";
  const props = item.properties || {};
  const messages = [];
  const itemSellingPlan = item.selling_plan_allocation;
  const isPreorderProduct = item.properties?._timesact_preorder;
  const sellingPlanName = itemSellingPlan?.selling_plan?.name?.toLowerCase() || "";
  const isQuarterly = !!props["_quaterly_subs_key"];
  const isBogo = item.discounts?.some(d => d.title.includes("BOGO"));
  const isSaveMore = item.discounts?.some(d => d.title.includes("BUY MORE SAVE MORE"));
  const finalPrice = item.final_price;
  const IS_US = window.localization.market === "us";

  let saleDiscount = 0;
  let compareAtPrice =  getCompareAtPrice(item, props);

  if(props["_discount_message"]) {
    messages.push(props["_discount_message"]);
  }

  if (isBogo || isSaveMore) {
      item.discounts?.forEach(d => messages.unshift(d.title));
      return messages.join("<br>");
  }

  // 1️⃣ Quarterly subscription
  if (isQuarterly) {
    if (compareAtPrice && compareAtPrice > 0) {
      saleDiscount = calculateDiscountRebuy(finalPrice, compareAtPrice);
      if (saleDiscount > 0) messages.unshift(`${saleDiscount}% OFF QUARTERLY SUBSCRIPTION`);
    }
    return messages.join("<br>");
  }

  // 2️⃣ Subscription discount (non-prepaid, not quarterly, not BOGO)
  if (itemSellingPlan) {
    if (compareAtPrice && compareAtPrice > 0) {
      saleDiscount = calculateDiscountRebuy(finalPrice, compareAtPrice);
       if (saleDiscount > 0) messages.unshift(`Save ${saleDiscount}% off ${isPreorderProduct ? "preorder" : "subscription"}`);
    }
    return messages.join("<br>");
  }

  // 3️⃣ Static or dynamic sale discount
  if(compareAtPrice && compareAtPrice > finalPrice) {
      if (compareAtPrice && compareAtPrice > 0) {
        saleDiscount = calculateDiscountRebuy(finalPrice, compareAtPrice);

        if (saleDiscount > 0) {
            messages.unshift(`Save ${saleDiscount}% off Sale`);
        }
      }
    return messages.join("<br>");
  }

}


function calculateDiscountRebuy(part, total) {
  //console.log("calculateDiscountRebuy", part, total);
  part = parseFloat(part);
  total = parseFloat(total);

  if (isNaN(part) || isNaN(total) || total === 0 || part >= total) {
    return 0;
  }

  return Math.round(((total - part) / total) * 100);
}


// Helper: read a property regardless of Rebuy or Shopify format
function getLineProperty(lineItem, key) {
  const props = lineItem?.properties;
  if (!props) return null;

  if (Array.isArray(props)) {
    const found = props.find(p => (p?.name || p?.key) === key);
    return found ? found.value ?? null : null;
  }

  if (typeof props === 'object') return props[key] ?? null;

  return null;
}

/**
 * Renders checkout-style bundle view with images + accordion toggle
 * Usage: <div class="custom-bundle" v-html="renderCustomBundle(item)"></div>
 */
function renderCustomBundle(bundleLineItem) {
  const raw = getLineProperty(bundleLineItem, '_bundle_items');
  if (!raw) return '';

  let items;
  try {
    items = JSON.parse(raw);
  } catch {
    return '';
  }
  if (!Array.isArray(items) || items.length === 0) return '';

  const count = items.length;
  const itemWord = count === 1 ? 'item' : 'items';

  const itemsHTML = items
    .map(
      (it) => `
        <div class="custom-bundle__item">
          <img src="${it.img}" alt="${it.title}" class="custom-bundle__img" loading="lazy" />
          <div class="custom-bundle__details">
            <span>${it.quantity || '1'} x ${it.title || ''}</span>
            ${it.variant_title ? `<small>${it.variant_title}</small>` : ''}
          </div>
        </div>`
    )
    .join('');

  return `
    <div class="custom-bundle" data-custom-bundle>
      <button class="custom-bundle__toggle" type="button">
        <span class="custom-bundle__toggle-text">Hide ${count} ${itemWord}</span>
        <svg class="custom-bundle__icon" width="12" height="12" viewBox="0 0 12 12">
          <path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/>
        </svg>
      </button>
      <div class="custom-bundle__items">${itemsHTML}</div>
    </div>
  `;
}

// Global accordion listener (only needs to run once)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.custom-bundle__toggle');
  if (!btn) return;

  const wrap = btn.closest('.custom-bundle');
  const items = wrap.querySelector('.custom-bundle__items');
  const text = btn.querySelector('.custom-bundle__toggle-text');
  const isCollapsed = wrap.classList.toggle('collapsed');

  items.style.display = isCollapsed ? 'none' : 'block';
  const total = items.children.length;
  text.textContent = isCollapsed
    ? `Show ${total} ${total === 1 ? 'item' : 'items'}`
    : `Hide ${total} ${total === 1 ? 'item' : 'items'}`;
});

window.renderCustomBundle = renderCustomBundle;